export default "__VITE_ASSET__DrMqwYea__"